import {useResources} from "../stores/ResourceProvider";
import Dialog from "@mui/material/Dialog";
import {Box, Paper, Typography, useTheme} from "@mui/material";
import {Link} from "@reach/router";
import CheckImg from "../images/Check_1Check.png";
import ProgressButton from "./form/ProgressButton";
import globalStyles from "../styles/globalStyles";
import * as React from "react";
import {ReactElement, useEffect, useState} from "react";
import {isoToLocalDate} from "../stores/StoreUtilities";
import {differenceInCalendarDays, startOfToday} from "date-fns";
import DialogButton from "./form/DialogButton";


const FreeTrialDialog = ({
  open,
  onAction
} : {
  open: boolean,
  onAction: (action: string) => void
}) => {
  const [trialDaysRemaining, setTrialDaysRemaining] = useState<number>(0)
  const [heading, setHeading] = useState<ReactElement | string>("")

  const theme = useTheme()
  const {userStore} = useResources()

  const styles = {
    dialogContent: {
      px:2,
      py:2,
      '&.MuiDialogContent-root': {
        paddingLeft: "16px",
        paddingRight: "16px"
      }
    },
    link: {
      color: theme.palette.primary.main,
      fontSize: 16,
      fontWeight: 400,
      textDecoration: "none"
    }
  }

  useEffect(() => {
    if (userStore.user) {
      const trialEnd = userStore.user.trialEndDate
      if (trialEnd) {
        const trialEndDate = isoToLocalDate(trialEnd)
        const daysRemaining = differenceInCalendarDays(trialEndDate, startOfToday())
        setTrialDaysRemaining(daysRemaining)

        if (daysRemaining < 0) {
          setHeading("Your RBC Premium Trial has ended!")
        } else if (daysRemaining === 0) {
          setHeading(`Your RBC Premium Trial is ending today!`)
        } else if (daysRemaining === 1) {
          setHeading(`Your RBC Premium Trial is ending tomorrow!`)
        } else {
          setHeading(`Your RBC Premium Trial is ending in ${daysRemaining} days!`)
        }
      }
    }
  }, [userStore.user])

  // const handleAction = (action: string) => {
  //   onAction(action)
  // }

  return (
    <Dialog
      id="FreeTrialDialog"
      open={open}
      // onClose={() => onAction("close")}
      maxWidth="sm"
      aria-modal={true}
      aria-labelledby="FreeTrialDialog-title"
    >
      {/*<DialogContent sx={styles.dialogContent}>*/}
      {/*  */}
      {/*</DialogContent>*/}
      <Paper elevation={2} sx={styles.dialogContent}>
        <Box>
          <Typography variant="h3" color="primary" gutterBottom>
            {heading}
          </Typography>
          <Typography variant="body1" gutterBottom>
            We invite you to subscribe to RBC Premium and continue to enjoy these Premium Features:
          </Typography>
          <div className="list-div">
            <div className="advsor-feature">
              <img
                alt=""
                loading="lazy"
                src={CheckImg}
                className="checkmark-icon"
              />
              <div>Retirement Optimizer</div>
            </div>
            <div className="advsor-feature">
              <img
                alt=""
                loading="lazy"
                src={CheckImg}
                className="checkmark-icon"
              />
              <div>Tax Estimator</div>
            </div>
            <div className="advsor-feature">
              <img
                alt=""
                loading="lazy"
                src={CheckImg}
                className="checkmark-icon"
              />
              <div>AI Financial Assistant (Finn)</div>
            </div>
            <div className="advsor-feature">
              <img
                alt=""
                loading="lazy"
                src={CheckImg}
                className="checkmark-icon"
              />
              <div>RBC Community Access</div>
            </div>
          </div>
          <Typography variant="body2" gutterBottom>
            If you have questions, please email <Link to="." onClick={() => window.open('mailto:support@retirementbudgetcalculator.com', "_blank")} style={styles.link}>
            support@retirementbudgetcalculator.com
          </Link>.
          </Typography>
          <Box display="flex" justifyContent="space-evenly" alignItems="center" mt={2}>
            <ProgressButton
              size="large"
              variant="contained"
              color="secondary"
              sx={globalStyles.webFlowButton}
              type="button"
              onClick={() => onAction("subscribe")}
            >
              Subscribe to RBC Premium
            </ProgressButton>
            <DialogButton
              size="large"
              variant="primary"
              type="button"
              onClick={() => onAction(trialDaysRemaining >= 0 ? "trial" : "free")}
            >
              {trialDaysRemaining >= 0 ? "Continue RBC Premium Trial" : "Continue with RBC Free Version"}
            </DialogButton>
          </Box>
        </Box>
      </Paper>
    </Dialog>
  )
}

export default FreeTrialDialog
